import { useDialogStore } from '~/store/dialog/dialogStore';
import DialogType from '~/components/Common/Dialog/model/DialogType';
import type { GenericDialogProps } from '~/components/Common/Dialog/model/GenericDialogProps';
import { useI18n } from 'vue-i18n';
import { useRouter } from 'vue-router';
import { useUserStore } from '~/store/user/userStore';
import { RouteName } from '~~/package/enum/RouteName';
import { UserOrgSettingsMenuType } from "~/components/User/Settings/Common/model/UserOrgSettingsMenuType";

export function useGenericDialog() {
    const dialogStore = useDialogStore();
    const { t } = useI18n();
    const router = useRouter();
    const userStore = useUserStore();

    function openGenericAlert(
        props: GenericDialogProps,
        options?: {
            confirm?: { title?: string; event: () => void };
            close?: { title?: string; event: () => void };
        }
    ) {
        dialogStore.open({ type: DialogType.GenericAlert, props, ...options });
    }

    function openGenericConfirm(
        props: GenericDialogProps,
        options: {
            confirm: { title?: string; event: () => void };
            close?: { title?: string; event: () => void };
            exit?: { event: () => void };
        }
    ) {
        dialogStore.open({ type: DialogType.GenericConfirm, props, ...options });
    }

    function openWrongApproachAlert() {
        openGenericAlert(
            {
                title: t('common-wrong-approach-title'),
                contents: t('common-wrong-approach-content'),
            },
            {
                confirm: {
                    event: () => router.replace({
                        name: userStore.isLogin() ? RouteName.Dashboard : RouteName.Home,
                    }),
                },
            }
        );
    }

    function openSkillCertifySubscriptionNullAlert() {
        openGenericAlert(
          {
              title: t('skillCertify-creation-restriction-info-1-title'),
              contents: t('organization-subscription-none-description-2'),
          },
          {
              confirm: {
                  title: t('organization-subscription-none-button'),
                  event: () => router.replace({ path: '/home/pricing' }),
              },
              close: {
                  event: () => router.replace({ path: '/dashboard' })
              }
          }
        );
    }

    function openSkillCertifySubscriptionExpireAlert() {
        openGenericAlert(
          {
              title: t('skillCertify-creation-restriction-info-2-title'),
              contents: t('credit-history-top-up-credits-restriction-info-2-description'),
          },
          {
              confirm: {
                  title: t('payment-complete-button'),
                  event: () => router.replace({ path: '/settings/org', query: { tab: UserOrgSettingsMenuType.PAYMENT } }),
              },
              close: {
                  event: () => router.replace({ path: '/dashboard' })
              }
          }
        );
    }

    return {
        openGenericAlert,
        openGenericConfirm,
        openWrongApproachAlert,
        openSkillCertifySubscriptionNullAlert,
        openSkillCertifySubscriptionExpireAlert
    };
}
